// extracted by css-extract-rspack-plugin
export default {"centeredDiv":"_e0d017ef"};